export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00232.7f809cf2.png";